import React from 'react';
import { TouchableOpacity } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import Card from '../Card';
import { Icon } from '../Icon';
import { useTheme, Images } from '../Themes';
import VFText from '../VFText';

import styles from './ErrorCard.Styles';

const ErrorCard = ({
  iconName,
  iconStyle,
  text,
  textStyle,
  textButton,
  txtButtonStyle,
  iconButtonName,
  iconButtonStyle,
  onPress,
  showTryButton,
  tryTextAccessibilityLabel,
  tryIconAccessibilityLabel,
  iconAccessibilityLabel,
  textAccessibilityLabel,
  cardAccessibilityLabel,
  cardAccessible,
  allowFontScaling,
  cardStyle,
  iconSize,
}) => {
  const theme = useTheme();
  return (
    <Card
      style={[styles.cardStyle(theme), cardStyle]}
      cardAccessible={cardAccessible}
      accessibilityLabel={cardAccessibilityLabel}
    >
      <Icon
        name={iconName}
        type="image"
        size={iconSize}
        style={[styles.icon, iconStyle]}
        accessibilityLabel={iconAccessibilityLabel}
        testID={FoundationTestKeys.errorCardMainIcon}
      />
      <VFText
        i18nKey={text}
        style={[styles.text(theme), textStyle]}
        accessibilityLabel={textAccessibilityLabel}
        allowFontScaling={allowFontScaling}
        testKey={FoundationTestKeys.errorCardTitle}
      />
      {showTryButton && (
        <TouchableOpacity
          style={styles.tryButton}
          onPress={onPress}
          testID={FoundationTestKeys.tryButtonContainer}
        >
          <VFText
            i18nKey={textButton}
            style={[styles.txtButton(theme), txtButtonStyle]}
            accessibilityLabel={tryTextAccessibilityLabel}
            allowFontScaling={allowFontScaling}
            testKey={FoundationTestKeys.tryButtonText}
          />
          <Icon
            name={iconButtonName}
            type="image"
            size={20}
            style={[styles.iconButton, iconButtonStyle]}
            accessibilityLabel={tryIconAccessibilityLabel}
            testID={FoundationTestKeys.tryButtonIcon}
          />
        </TouchableOpacity>
      )}
    </Card>
  );
};

ErrorCard.defaultProps = {
  iconName: Images.warning,
  iconButtonName: Images.ic_RefreshRed,
  showTryButton: true,
  iconSize: 84,
  cardAccessibilityLabel: FoundationTestKeys.errorCard,
};

ErrorCard.propTypes = {
  iconName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ uri: PropTypes.string.isRequired }),
  ]),
  iconStyle: ViewPropTypes.style,
  text: PropTypes.string,
  textStyle: ViewPropTypes.style,
  textButton: PropTypes.string,
  txtButtonStyle: ViewPropTypes.style,
  cardStyle: ViewPropTypes.style,
  iconButtonName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ uri: PropTypes.string.isRequired }),
  ]),
  iconButtonStyle: ViewPropTypes.style,
  onPress: PropTypes.func,
  showTryButton: PropTypes.bool,
  cardAccessible: PropTypes.bool,
  tryTextAccessibilityLabel: PropTypes.string,
  tryIconAccessibilityLabel: PropTypes.string,
  iconAccessibilityLabel: PropTypes.string,
  textAccessibilityLabel: PropTypes.string,
  cardAccessibilityLabel: PropTypes.string,
  allowFontScaling: PropTypes.bool,
  iconSize: PropTypes.number,
};

export default ErrorCard;
